const { makeStyles } = require("@material-ui/core");

const useStyles = makeStyles( (theme) => ({
	m10: {
		margin: '0 10px'
	}
}))

export default useStyles